import { inject, Injectable } from '@angular/core';
import { SqliteService } from '@app/services';
import { ProductCategoryModel } from '@app/models';

@Injectable({
    providedIn: 'root',
})
export class ProductCategoryRepository
{
    private readonly keys = {
        tableName: 'product_categories',
    };
    private sqliteService = inject(SqliteService);

    async saveProductCategories(categories: ProductCategoryModel[]): Promise<void>
    {
        const columns = [
            'id',
            'external_id',
            'name',
        ];
        const valuePlaceholders = this.sqliteService.getValuePlaceholder(categories.length, columns.length);
        const sql = `
            INSERT INTO ${this.keys.tableName} (${columns.join(', ')})
            VALUES ${valuePlaceholders} ON CONFLICT(id) DO
            UPDATE
                SET
                    external_id = excluded.external_id,
                name = excluded.name;
        `;
        const values: any[] = categories.flatMap((p) => [
            p.id,
            p.external_id,
            p.name,
        ]);
        await this.sqliteService.save(sql, values);
    }

    async getProductCategories(): Promise<ProductCategoryModel[]>
    {
        const sql = `
            SELECT *
            FROM ${this.keys.tableName};
        `;

        const data = await this.sqliteService.get(sql) ?? [];

        return data as ProductCategoryModel[];
    }
}
